import {BehaviorSubject} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';
import {defaultFiatCurrencyByHost} from '@/helper/localized-site';
import {wwData$} from '@/streams/worker-data';
import {UNIT_TYPES} from '@/modules/assets/overview/const';

export const fiatCurrency$ = new BehaviorSubject(defaultFiatCurrencyByHost); // 兑换货币

// local currency/BTC/USDT
export const assetUnit$ = new BehaviorSubject(UNIT_TYPES.LOCAL_CURRENCY); // 资产单位

// 将法币单位发送到web worker用作单位转换
fiatCurrency$.pipe(distinctUntilChanged()).subscribe((currency) => wwData$.send({type: 'update-fiat', currency}));
